import { createContext, useContext } from 'react';
import { VerifiedShop } from '../services/orderLookupService';

// #72: init state of a parcel QR opened full screen (`/order-form-page?rq=`
// without proof and shop). PENDING: neutral, no shop. SUCCESS: the verified
// shop is installed. FAILURE: generic screen, no shop at all.
export type StandaloneQrStatus = 'pending' | 'success' | 'failure';

// #125: the shop of the signed return shown in the header of the status page,
// stored with the key of the link it was loaded for (`<id>|<sig>`); App shows
// it only while the current route has the same key.
export interface HeaderShop {
  key: string;
  shop: VerifiedShop;
}

// the key of a signed status link; no signature, no key
export const statusPageKey = (
  id: string | undefined,
  sig: string | null
): string | null =>
  id && sig ? `${encodeURIComponent(id)}|${encodeURIComponent(sig)}` : null;

export interface StandaloneQrContextValue {
  active: boolean;
  handoff?: boolean;
  account?: string | null;
  status: StandaloneQrStatus;
  shop: VerifiedShop | null;
  // installs shop, client token and display identity in one step
  succeed: (shop: VerifiedShop, token: string) => void;
  fail: () => void;
  // #125: set by the status page after its signed load, cleared otherwise
  setHeaderShop: (headerShop: HeaderShop | null) => void;
}

export const StandaloneQrContext = createContext<StandaloneQrContextValue>({
  active: false,
  status: 'pending',
  shop: null,
  succeed: () => undefined,
  fail: () => undefined,
  setHeaderShop: () => undefined,
});

export const useStandaloneQr = () => useContext(StandaloneQrContext);
